import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Exception } from './Exception';
import { defaults } from '../utils';

/**
 * 公共参数
 */
var baseReqParams = {
  lang: window.navigator.language
};
/**
 * 设置公共参数
 * @param obj
 * @returns
 */

export function setBaseReqParams(obj) {
  Object.assign(baseReqParams, obj);
  return _objectSpread({}, baseReqParams);
}
export var Flow = /*#__PURE__*/function () {
  function Flow(params) {
    _classCallCheck(this, Flow);

    _defineProperty(this, "_encrypt", function (content) {
      return content;
    });

    this._baseURL = typeof (params === null || params === void 0 ? void 0 : params.baseURL) === 'string' ? params.baseURL.replace(/\/+$/, '') : this._baseURL;
    this._appid = params === null || params === void 0 ? void 0 : params.appid;
    this._subappid = params === null || params === void 0 ? void 0 : params.subappid;
    this._encrypt = typeof (params === null || params === void 0 ? void 0 : params.encrypt) === 'function' ? params.encrypt : this._encrypt;
    this._onXhrError = typeof (params === null || params === void 0 ? void 0 : params.onXhrError) === 'function' ? params.onXhrError : this._onXhrError;
  }
  /** 存储COOKIES */


  _createClass(Flow, [{
    key: "name",
    get:
    /** 流程名称 */

    /** 请求基础路径 */

    /** 业务 Appid */

    /** 业务子 Appid(店铺id) */

    /** 流程TOKEN */

    /** 存储服务 */

    /** 请求服务 */

    /** 上次初始化返回值 */

    /** 加密方法 */

    /** 当前名称 */
    function get() {
      var _this$constructor;

      return (_this$constructor = this.constructor) === null || _this$constructor === void 0 ? void 0 : _this$constructor['flowName'];
    }
  }, {
    key: "setCookies",
    value: function () {
      var _setCookies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cookies, options) {
        var _this = this;

        var keys, tasks;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keys = Object.keys(cookies);
                tasks = keys.map(function (name) {
                  return _this._storage.setCookie(name, cookies[name], options);
                });
                return _context.abrupt("return", Promise.all(tasks));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function setCookies(_x, _x2) {
        return _setCookies.apply(this, arguments);
      }

      return setCookies;
    }()
    /** 设置缓存 */

  }, {
    key: "setCache",
    value: function setCache(name, value) {
      return this._storage.setCache(name, value);
    }
    /** 获取缓存 */

  }, {
    key: "getCache",
    value: function getCache(name) {
      return this._storage.getCache(name);
    }
    /** 删除缓存 */

  }, {
    key: "removeCache",
    value: function removeCache(name) {
      return this._storage.removeCache(name);
    }
    /** 获取参数 */

  }, {
    key: "resolveReqParams",
    value: function resolveReqParams(params) {
      var appid = this._appid,
          subappid = this._subappid,
          stoken = this._stoken;
      return defaults(params, _objectSpread(_objectSpread({}, baseReqParams), {}, {
        appid: appid,
        subappid: subappid,
        stoken: stoken
      }));
    }
    /** 获取空的参数名称 */

  }, {
    key: "getNamesFromEmptyParams",
    value: function getNamesFromEmptyParams(params) {
      return Object.keys(params).filter(function (name) {
        return typeof params[name] === 'undefined';
      });
    }
    /** 请求 */

  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, params) {
        var finalParams, response, _ref, code, message, stoken, extras;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                finalParams = this.resolveReqParams(params);
                _context2.next = 3;
                return this._requestor.request(this._baseURL + url, finalParams);

              case 3:
                response = _context2.sent;
                _ref = response || {}, code = _ref.rescode, message = _ref.resmsg, stoken = _ref.stoken;

                if (!(code !== '0')) {
                  _context2.next = 9;
                  break;
                }

                if (typeof this._onXhrError === 'function') {
                  this._onXhrError({
                    code: code,
                    message: message,
                    url: url
                  });
                }

                extras = {
                  url: url,
                  params: finalParams,
                  response: response
                };
                throw new Exception({
                  code: code,
                  message: message,
                  extras: extras
                });

              case 9:
                this._stoken = typeof stoken === 'string' ? stoken : undefined;
                return _context2.abrupt("return", response);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function request(_x3, _x4) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
    /** 使用加密方法 */

  }, {
    key: "useEncryption",
    value: function useEncryption(fn) {
      if (typeof fn === 'function') {
        this._encrypt = fn;
      }
    }
    /** 销毁 */

  }, {
    key: "destroy",
    value: function destroy() {
      this._baseURL = undefined;
      this._appid = undefined;
      this._subappid = undefined;
      this._stoken = undefined;
    }
    /** 加密 */

  }, {
    key: "encrypt",
    value: function encrypt(string) {
      return this._encrypt(string);
    }
  }]);

  return Flow;
}();